import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { useTheme } from "@mui/material";

const LineChart = ({ orders = [] }) => {
  const theme = useTheme();
  const [options, setOptions] = useState({});

  useEffect(() => {
    // Procesamos las órdenes para mostrar la tendencia de ventas por fecha
    // Organizamos los datos por fecha
    const salesByDate = {};
    const ordersByDate = {};

    orders.forEach(order => {
      // Extraemos solo la fecha (sin hora)
      const date = new Date(order.createdAt).toLocaleDateString('es-ES');
      const amount = parseFloat(order.total_cost);

      if (salesByDate[date]) {
        salesByDate[date] += amount;
        ordersByDate[date] += 1;
      } else {
        salesByDate[date] = amount;
        ordersByDate[date] = 1;
      }
    });

    // Convertimos a arrays para el gráfico
    const dates = Object.keys(salesByDate).sort((a, b) => 
      new Date(a.split('/').reverse().join('-')) - new Date(b.split('/').reverse().join('-'))
    );
    const sales = dates.map(date => parseFloat(salesByDate[date].toFixed(2)));
    const orderCounts = dates.map(date => ordersByDate[date]);

    setOptions({
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#6a7985'
          }
        },
        formatter: function(params) {
          const date = params[0].name;
          let result = `<div>${date}</div>`;
          
          params.forEach(param => {
            const color = param.color;
            const seriesName = param.seriesName;
            const value = param.seriesName === 'Ventas' 
              ? new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(param.value)
              : param.value;
              
            result += `<div style="display: flex; align-items: center;">
              <span style="display: inline-block; margin-right: 5px; border-radius: 50%; width: 10px; height: 10px; background-color: ${color};"></span>
              <span>${seriesName}: ${value}</span>
            </div>`;
          });
          
          return result;
        }
      },
      legend: {
        data: ['Ventas', 'Pedidos'],
        bottom: 0
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '10%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: dates,
        axisLabel: {
          rotate: 45
        }
      },
      yAxis: [
        {
          type: 'value',
          name: 'Ventas (€)',
          position: 'left'
        },
        {
          type: 'value',
          name: 'Pedidos',
          position: 'right'
        }
      ],
      series: [
        {
          name: 'Ventas',
          type: 'line',
          stack: 'Total',
          smooth: true,
          lineStyle: {
            width: 3
          },
          areaStyle: {
            opacity: 0.3
          },
          emphasis: {
            focus: 'series'
          },
          data: sales,
          yAxisIndex: 0,
          color: '#5470c6'
        },
        {
          name: 'Pedidos',
          type: 'line', // Cambiado de 'bar' a 'line'
          smooth: true, // Añadir smooth para hacer la línea curva
          lineStyle: {
            width: 2, // Un poco más delgada que la otra línea
            type: 'dashed' // Hacer esta línea discontinua para diferenciarla
          },
          emphasis: {
            focus: 'series'
          },
          data: orderCounts,
          yAxisIndex: 1,
          color: '#91cc75'
        }
      ]
    });
  }, [orders]);

  return <ReactECharts option={options} style={{ height: '100%' }} />;
};

export default LineChart;
